import { style } from '@/styles/globals';
import { lunarYear } from '@/utils/seoHelper';
import TableFare from './TableFare';
import SectionTetTicket from './SectionManager/SectionTetTicket';
import SectionTetTicketCalendar from './SectionManager/SectionTetTicketCalendar';
import SectionAirline from './SectionManager/SectionAirline';
import SectionFamousPlace from './SectionManager/SectionFamousPlace';
import SectionCompanyFamousRoute from './SectionManager/SectionFamousRoute';
import SectionPartner from '../RouteCompanyCityToCity/SectionManager/SectionPartner';
import SectionPartnerDesktop from '../RouteCompanyCityToCity/SectionManager/SectionPartner/desktop';
import SectionWhyBookUs from '../RouteCompanyCityToCity/SectionManager/SectionWhyBookUs';
import SectionWhyBookUsDesktop from '../RouteCompanyCityToCity/SectionManager/SectionWhyBookUs/desktop';

export const CONTENT_SECTION = ({ isDesktop }: { isDesktop?: boolean }) => ({
  section1: {
    isNewYear: false,
    alignCenter: true,
    isHaveDivider: true,
    id: 'san-ve',
    title: {
      vi: 'Vé máy bay {{company}} giá rẻ Tết {{luna_year}}',
      component: 'h2',
    },
    title2: {
      vi: 'Bảng giá vé máy bay Tết {{luna_year}} giá rẻ nhất của {{company}}',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [
        'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
        'Thời gian khởi hành theo giờ địa phương',
        'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn.',
      ],
    },
    description: {
      vi: `Vé máy bay {{company}} Tết {{luna_year}} đã mở bán. Bạn hãy nhanh tay đặt vé sớm để có mức giá tốt nhất nhé.
      <br/>
      <br/>
      Nhập điểm đi mong muốn để xem giá vé máy bay rẻ nhất`,
    },
    component: SectionTetTicket,
  },
  section2: {
    isNewYear: false,
    alignCenter: true,
    id: 've-tet',
    title: {
      vi: 'Giá vé máy bay {{company}} Tết {{luna_year}} rẻ nhất cập nhật {{route_now}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Giá vé máy bay Tết {{luna_year}} được cập nhật liên tục trên Goyolo.com để giúp cho hành khách có những tấm vé máy bay Tết giá rẻ nhất. Ngay từ {{route_now}}, hãng hàng không {{company}} đã mở bán vé máy bay Tết {{luna_year}}. Hãy chọn điểm đi và điểm đến để cùng Goyolo.com theo dõi bảng giá vé ngày Tết {{luna_year}}',
    },
    component: SectionTetTicketCalendar,
  },
  section3: {
    id: 've-tet',
    alignCenter: true,
    title: {
      vi: 'Thời điểm săn vé máy bay {{company}} Tết {{luna_year}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Khi có lịch nghỉ Tết Ta {{luna_year}}, bạn nên tiến hành book ngay vé máy bay Tết đi {{to_name}} của {{company}}. Bí kíp là bạn cũng có thể đặt vé trước vài tháng vì mua vé càng sớm, bạn sẽ dễ dàng lựa chọn được ngày giờ bay ưng ý với mức giá khuyến mãi rẻ nhất. Tìm vé càng cận Tết sẽ dễ rơi vào tình huống cháy vé hoặc phải mua vé với giá cao ngất ngưỡng. Vậy việc booking vé Tết càng sớm luôn có lợi hơn cả.`,
    },
    component: null,
  },
  section4: {
    id: 've-tet',
    alignCenter: true,
    title: {
      vi: 'Lịch bán vé máy bay Tết {{luna_year}} của {{company}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Hãng hàng không {{company}} sẽ mở bán vé Tết trong 3 đợt. Đợt bán vé đầu tiên thường bắt đầu tầm giữa tháng 9 và tháng 10, đợt 2 tầm tháng 10 và tháng 11, đợt còn lại cho đến Tết. Thường thì vé được bán trong đợt 1 có giá rẻ nhất với số lượng nhiều nhất, càng về gần Tết vé máy bay càng ít dần và giá càng bị đẩy lên cao theo cơ chế cung cầu. Do đó, thời điểm săn mua vé máy bay Tết {{luna_year}} tốt hơn hết bạn nên mua vé ngay khi hãng mở bán trong đợt đầu tiên để có thể chắc chắn mình mua được vé với giá tốt nhất.`,
    },
    component: null,
  },
  section5: {
    id: 've-tet',
    isHaveDivider: true,
    title: {
      vi: 'Mẹo săn vé máy bay giá rẻ nhất của {{company}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Hiện tại theo cập nhật mới nhất của Goyolo.com, hãng hàng không {{company}} đang khai thác khá nhiều đường bay là các điểm đến phổ biến, trong đó giá vé rẻ nhất là đường bay <a style="color:${style.color.product3};font-weight: bold;" href="{{route_url}}"> {{company}} từ {{from_name}} đi {{to_name}}</a> với giá chỉ từ {{min_fare}}`,
    },
    component: null,
  },
  section6: {
    id: 've-tet',
    alignCenter: true,
    isHaveDivider: true,
    title: {
      vi: 'Lịch bay, giá vé thấp nhất các chặng bay phổ biến của hãng bay {{company}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    description: {
      vi: '',
    },
    component: TableFare,
  },
  section7: {
    id: 've-tet',
    isHaveDivider: true,
    title: {
      vi: 'Các hãng bay nội địa ở Việt Nam',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionAirline,
  },
  section8: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Điểm đến phổ biến của {{company}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousPlace,
  },
  section9: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Chặng bay phổ biến của {{company}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionCompanyFamousRoute,
  },
  SectionParner: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Hơn 1500+ đối tác của Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionPartnerDesktop : SectionPartner,
  },
  SectionWhyBookUs: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Tại sao bạn nên đặt vé qua Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionWhyBookUsDesktop : SectionWhyBookUs,
  },
});

export const MENU_BAR = [
  { label: 'Tìm chuyến' },
  { label: 'Săn vé' },
  { label: 'Chính sách' },
  { label: 'Vé Tết' },
  { label: 'FAQ' },
  { label: 'Điểm đến' },
  { label: 'Giới thiệu' },
  { label: 'Mẹo săn vé' },
  { label: 'Lịch bay' },
  { label: 'Các hãng bay' },
];

export const LIST_UTILITIES = [
  {
    title: 'Vô vàn ưu đãi hấp dẫn',
    description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a',
    type: 'vn',
    img: '/images/wallet.png',
  },
  {
    title: 'Nhiều hình thức di chuyển',
    description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a',
    type: 'vj',
    img: '/images/flight.png',
  },
  {
    title: 'Đa dạng hình thức thanh toán',
    description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a',
    type: 'bb',
    img: '/images/wallet.png',
  },
];

export const LIST_ARILINES = [
  {
    type: 'vn',
    img: '/images/vn-airline.png',
    link: '/vn/ve-may-bay/vietnam-airlines.vi',
  },
  {
    type: 'vj',
    img: '/images/vj-airline.png',
    link: '/vn/ve-may-bay/vietjet-air.vi',
  },
  {
    type: 'bb',
    img: '/images/bambo-airline.png',
    link: '/vn/ve-may-bay/bamboo-airways.vi',
  },
];

export const REWARDS = [
  {
    id: 1,
    title: 'Tôi không nhận được vé điện tử',
    content: '',
    isDuration: false,
    onClick: '',
  },
  {
    id: 2,
    title: 'Quy định phòng chống covid',
    content: '',
    isDuration: false,
    onClick: '',
  },
  {
    id: 3,
    title: 'Kiểm tra tình trạng chuyến bay',
    content: '',
    isDuration: false,
    onClick: '',
  },
  {
    id: 4,
    title: 'Chính sách hoàn tiền',
    content: '',
    isDuration: false,
    onClick: '',
  },
  {
    id: 5,
    title: 'Chính sách đổi lịch bay',
    content: '',
    isDuration: false,
    onClick: '',
  },
];

export const VE_TET = [
  {
    id: 1,
    title: `Lịch mở bán vé máy bay Tết năm ${lunarYear}`,
    content: '',
    onClick: '',
  },
  {
    id: 2,
    title: `Bảng giá vé máy bay Tết năm ${lunarYear}`,
    content: '',
    onClick: '',
  },
];

export const GUIDES_MANAGER = [
  // {
  //   id: 1,
  //   title: 'Hướng dẫn làm thủ tục check in online company_name',
  //   description: '',
  //   onClick: '',
  // },
  // {
  //   id: 2,
  //   title: 'Quy định về xét nghiệm covid và phòng dịch trước khi bay',
  //   description: '',
  //   onClick: '',
  // },
  // {
  //   id: 3,
  //   title: 'Thực hiện khai báo y tế điện tử',
  //   description: '',
  //   onClick: '',
  // },
  // {
  //   id: 4,
  //   title: 'chính sách thủ tục đi máy bay',
  //   description: '',
  //   onClick: '',
  // },
  // {
  //   id: 5,
  //   title: 'Quy định, giá và kích thước hành lý ký gửi và xách tay',
  //   description: '',
  //   onClick: '',
  // },
  {
    id: 6,
    title: 'Chính sách và phí hoàn hủy vé',
    description: '',
    onClick: '',
  },
  // {
  //   id: 7,
  //   title: 'Chính sách và phí đổi ngày, giờ bay',
  //   description: '',
  //   onClick: '',
  // },
];

export const FAQ = [
  {
    id: 1,
    title: 'Tôi không nhận được vé điện tử',
    description: '',
    onClick: '',
  },
  {
    id: 2,
    title: 'Tổi cần đổi giờ bay hoặc thêm hành lý',
    description: '',
    onClick: '',
  },
  {
    id: 3,
    title: 'Giá vé trẻ em tính như thế nào',
    description: '',
    onClick: '',
  },
  {
    id: 4,
    title: 'Tôi có thể mang gì lên máy bay',
    description: '',
    onClick: '',
  },
];

export const BRANCH_INFO = [
  {
    id: 1,
    title: 'Giới thiệu company_name',
    description: '',
    onClick: '',
  },
  {
    id: 2,
    title: 'Hình ảnh company_name',
    description: '',
    onClick: '',
  },
  {
    id: 3,
    title: 'Số điện thoại và địa chỉ phòng vé hãng hàng không company_name ở các tỉnh',
    description: '',
    onClick: '',
  },
  {
    id: 4,
    title: 'Tôi có thể mang gì lên máy bay',
    description: '',
    onClick: '',
  },
  {
    id: 5,
    title: 'Tổng đài Chăm sóc khách hàng',
    description: '',
    onClick: '',
  },
  {
    id: 6,
    title: 'Đội bay và các loại ghế',
    description: '',
    onClick: '',
  },
  {
    id: 7,
    title: 'Chính sách Các hạng ghế company_name',
    description: '',
    onClick: '',
  },
  {
    id: 8,
    title: 'Hotline đặt vé máy bay company_name 247',
    description: '',
    onClick: '',
  },
];

export const TABLE_FARE = [
  {
    id: 1,
    from_name: 'Hồ Chí Minh',
    to_name: 'Hà Nội',
    available_trip: 2,
    min_price: 250000,
    fromData: {
      id: '29',
      location: 'Hồ Chí Minh',
      country: 'Việt Nam',
      highlight: '',
      airports: [
        {
          id: '28284',
          nameVn: 'Sân bay Tân Sơn Nhất',
          nameEn: 'Tan Son Nhat International Airport',
          distance: '8.67314724377464',
          airportCode: 'SGN',
          highlight: 'Sân bay Tân Sơn Nhất',
        },
      ],
    },
    toData: {
      id: '24',
      location: 'Hà Nội',
      country: 'Việt Nam',
      highlight: '',
      airports: [
        {
          id: '102188',
          nameVn: 'Sân bay Nội Bài',
          nameEn: 'Noi Bai International Airport',
          distance: '41.26032025866256',
          airportCode: 'HAN',
          highlight: 'Sân bay Nội Bài',
        },
      ],
    },
  },
  {
    id: 2,
    from_name: 'Hà Nội',
    to_name: 'Hồ Chí Minh',
    available_trip: 2,
    min_price: 250000,
    toData: {
      id: '29',
      location: 'Hồ Chí Minh',
      country: 'Việt Nam',
      highlight: '',
      airports: [
        {
          id: '28284',
          nameVn: 'Sân bay Tân Sơn Nhất',
          nameEn: 'Tan Son Nhat International Airport',
          distance: '8.67314724377464',
          airportCode: 'SGN',
          highlight: 'Sân bay Tân Sơn Nhất',
        },
      ],
    },
    fromData: {
      id: '24',
      location: 'Hà Nội',
      country: 'Việt Nam',
      highlight: '',
      airports: [
        {
          id: '102188',
          nameVn: 'Sân bay Nội Bài',
          nameEn: 'Noi Bai International Airport',
          distance: '41.26032025866256',
          airportCode: 'HAN',
          highlight: 'Sân bay Nội Bài',
        },
      ],
    },
  },
];

export const TIPS = {
  content: `Hiện tại theo cập nhật mới nhất của Goyolo.com, hãng hàng không company_name đang  khai thác khá nhiều đường bay là các điểm đến phổ biến, trong đó giá vé rẻ nhất là đường bay [link] với giá chỉ từ [fare].

  Các tháng hãng hàng không company_name có giá thấp nhất trong năm là tháng {2 Tháng có giá thấp nhất theo dữ liệu} do Data chưa có

  Nhìn chung giá vé hạng ghế [seat_name_min_fare] của hãng company_name ở các đường bay phổ biến sẽ có giá thấp vào các ngày {2 ngày trong tuần có giá thấp nhất, theo data tháng tiếp theo} và các khung giờ {2 khung giờ có giá thấp nhất theo data tháng tiếp theo}
`,
};

export const DEFAULT_SEO_FROM = ['SGN'];
export const DEFAULT_SEO_TO = ['HAN'];
